/* eslint-disable quotes */
/* eslint-disable max-lines */
export default {
  new_feature_notification: {
    check_out_new_feature: 'Descoperă noua funcționalitate!'
  },
  change_request_modal: {
    title: 'Cererea de modificare a fost trimisă',
    message:
      'Cererea dvs. de editare a fost trimisă cu succes. Vă rugăm să așteptați aprobarea administratorului înainte de a continua.',
    got_it: 'Am înțeles'
  },
  blocked_app_modal: {
    title: 'Cont blocat',
    message: 'Contul dvs. a fost blocat. Pentru mai multe informații, vă rugăm să contactați administratorul.',
    contact_admin: 'Contactează administratorul',
    additional_info:
      'Dacă credeți că aceasta este o eroare sau aveți nevoie de asistență imediată, vă rugăm să contactați echipa noastră de suport. Ne cerem scuze pentru orice inconveniență pe care ar putea-o cauza.'
  },
  captcha_page: {
    title: 'Vă rugăm să confirmați că sunteți o persoană pentru a continua.',
    error: 'Verificarea a eșuat. Vă rugăm să încercați din nou.',
    expired: 'Verificarea a expirat. Vă rugăm să încercați din nou.',
    load_error: 'Nu s-a putut încărca verificarea. Vă rugăm să reîmprospătați pagina.',
    verifying: 'Se verifică...'
  },
  phone_confirmation_modal: {
    title: 'Confirmă numărul de telefon',
    description: 'Introdu numărul de telefon. Vom trimite un SMS la acest număr.',
    phone: 'Număr de telefon',
    phone_placeholder: '+48 111 222 333',
    send_sms: 'Trimite SMS',
    sending: 'Se trimite...',
    sent: 'SMS-ul a fost trimis.',
    too_soon: 'Așteaptă un minut înainte de a trimite un alt SMS.',
    limit_reached: 'Poți trimite cel mult 5 SMS-uri pe oră. Încearcă mai târziu.',
    phone_required: 'Numărul de telefon este obligatoriu',
    error: 'SMS-ul nu a putut fi trimis. Încearcă din nou.',
    code: 'Codul din SMS',
    code_placeholder: '123456',
    confirm: 'Confirmă',
    confirming: 'Se confirmă...',
    invalid_code: 'Codul este incorect.',
    code_required: 'Introdu codul din SMS.',
    confirm_error: 'Numărul de telefon nu a putut fi confirmat. Încearcă din nou.'
  },
  demo_modal: {
    demo_expired: 'Demo expirat',
    title: 'Vă vom ajuta să',
    title_highlight: 'activați accesul complet.',
    subtitle: 'Aveți întrebări despre platformă? Suntem aici să vă ajutăm.',
    badge: 'Acces complet pentru dealer',
    full_access_title: 'Acces complet',
    full_access_description: 'Pentru dealeri pregătiți să înceapă să caute motociclete și să facă profit.',
    price: '990€',
    price_period: '/ plată unică',
    features: {
      live_listings: 'Acces complet la anunțuri live, verificate de la vânzători privați',
      bid_buy: 'Capacitate completă de licitare sau cumpărare, cu control complet asupra transportului',
      priority_support: 'Onboarding prioritar și suport pentru dealer',
      mobile_app: 'Acces complet la aplicația mobilă'
    },
    support_text:
      'Dacă aveți întrebări despre acest pas sau despre platformă în sine, trimiteți-ne un email la partner@estigroup.de — echipa noastră va răspunde rapid pentru a vă ajuta să începeți.',
    form: {
      title: 'Completați detaliile companiei pentru a debloca accesul complet de cumpărare',
      description:
        'Avem nevoie de aceste informații pentru a pregăti acordul dvs. de dealer și pentru a activa capacitatea dvs. de a cumpăra vehicule pe platformă.',
      company_id: 'ID-ul companiei',
      company_id_placeholder: 'ID-ul dvs.',
      company_name: 'Numele companiei',
      company_name_placeholder: 'Numele companiei',
      address: 'Adresa',
      address_placeholder: 'Numele străzii',
      city: 'Orașul',
      city_placeholder: 'Numele orașului',
      postal_code: 'Codul poștal',
      postal_code_placeholder: 'Codul poștal',
      phone_number: 'Număr de telefon',
      phone_number_placeholder: 'Numărul dvs. de telefon',
      privacy_policy:
        'Prin trimiterea informațiilor mele confirm că am citit și înțeles Politica de Confidențialitate Estimoto',
      submit_button: 'Solicită acces complet',
      errors: {
        company_id_required: 'ID-ul companiei este obligatoriu',
        company_name_required: 'Numele companiei este obligatoriu',
        address_required: 'Adresa este obligatorie',
        city_required: 'Orașul este obligatoriu',
        postal_code_required: 'Codul poștal este obligatoriu',
        phone_number_required: 'Numărul de telefon este obligatoriu',
        privacy_policy_required: 'Trebuie să acceptați politica de confidențialitate'
      }
    }
  },
  test_access_banner: {
    demo_mode: 'Mod Demo',
    expires_on: 'Expiră pe',
    contact_support: 'Contactează suportul',
    upgrade_now: 'Actualizează acum'
  },
  pagination: {
    showing_items: '{{startItem}}-{{endItem}} din {{totalItems}} rezultate'
  },
  only_buy_now_dec: 'Afișează doar ofertele de cumpărare imediată',
  only_buy_now: 'Cumpără acum',
  just_sold: 'Vehicule vândute',
  in_realization_list_item: {
    contact_info: 'Contact',
    email: 'Email',
    phone: 'Telefon',
    help: 'Ajutor',
    arrange_transport: 'Organizează transportul',
    transport_arranged: 'Transport organizat',
    transport_arranged_long: 'Vehiculul a fost predat transportului',
    confirm_receipt: 'Confirmă ridicarea',
    vehicle_data: 'Specificații',
    contract_pdf: 'Confirmarea predării',
    spedition: 'Organizează ridicarea transportului',
    choose_spedition: 'Alege expeditorul',
    spedition_note: 'Mesaj pentru transport',
    spedition_terms_1: 'Prin plasarea comenzii, acceptați termenii și condițiile expeditorului selectat.',
    create_transport_button: 'Trimite comanda',
    confirm_pick_up: 'Vehiculul a fost cumpărat și ridicat cu succes.',
    confirm_button: 'Confirmă ridicarea',
    cancel: 'Anulează',
    accepted: 'Acceptat',
    credit_data: 'Detalii credit',
    price: 'Prețul vehiculului',
    provision: 'Comision',
    deregistering_person: 'Radiere vehicul',
    deregistering_person_dealer: 'Cumpărător (dealer)',
    deregistering_person_seller: 'Vânzător',
    deregistering_person_later: 'De decis ulterior',
    deregistering_person_already_deregistered: 'Vehiculul a fost radiat'
  },
  invoices_screen: {
    screen_title: 'Facturi'
  },
  bottom_menu: {
    sell: 'Vinde',
    search: 'Caută',
    want_to_buy: 'Cumpără',
    settings: 'Setări'
  },
  platform_terms: {
    title: 'Regulamentul platformei',
    files: [
      {
        label: 'Allgemeine zusätzliche Geschäftsbedingungen (AGB-Z)',
        href: '/Allgemeine zusätzliche Geschäftsbedingungen (AGB-Z).pdf'
      },
      { label: 'AGB Estigroup (DE)', href: '/AGB-ESTIGROUP-DE.pdf' }
    ]
  },
  soon: 'În curând',
  buy_now_modal: {
    title: 'Cumpără vehiculul acum',
    by_clicking: 'prin cumpărare acceptați',
    buy_now: 'Termenii',
    you_realize_sell: 'și',
    terms: 'Politica de Confidențialitate',
    buy_now_button: 'Confirmă',
    realization: 'Contactează vânzătorul',
    you_offer_has_been_sent: 'Felicitări \n Acum puteți \n contacta vânzătorul.',
    go_to_realization: 'Organizați o întâlnire pentru predare în 48 de ore sau organizați transportul pentru ridicare.'
  },
  auction_contract_modal: {
    by_clicking: '',
    you_are_accepting: '',
    title: 'Fă o ofertă corectă și realistă.',
    term: 'Oferta dvs. este obligatorie pentru <strong>14 zile</strong>. \n Prin plasarea unei oferte acceptați <strong>Termenii</strong> noștri.',
    price: 'Prețul.\n',
    offer_time: 'Oferta dvs.',
    offer_time_span: 'este obligatorie pentru 14 zile.',
    resign: 'Anulează',
    place_offer: 'Plasează oferta',
    place_offer_title: '',
    go_to_bets: 'Ofertele mele',
    your_offer_has_been_sent: 'Oferta a fost trimisă.',
    go_to_bets_desc: 'Mergi la cumpărăturile tale \n pentru a urmări progresul.',
    only_fail_offer_will_be_sent: `
    Dacă oferta dvs. este prea departe de un preț de cumpărare realist, \n nu suntem obligați să o trimitem vânzătorului.
    Puteți vedea statusul actual \n al ofertelor dvs. \n în cumpărăturile tale.`,
    we_will_notify: ''
  },
  single_offer: {
    check_price_on_mobile: 'Verifică prețul',
    roadworthy: 'În stare de funcționare',
    not_roadworthy: 'Nu este în stare de funcționare',
    gross_vehicle_weight: 'Greutatea brută a vehiculului',
    length: 'Lungimea',
    width: 'Lățimea',
    engine_capacity: 'Capacitatea motorului',
    engine_power: 'Puterea',
    automatic_gearbox: 'Transmisie automată',
    date_of_first_registration: 'Prima înmatriculare',
    year_of_production: 'Prima înmatriculare',
    added: 'Publicat',
    ago: '-',
    unread_messages: 'Mesaj',
    screen_title: 'Detalii vehicul',
    gallery: 'Imagini',
    your_highest: 'Oferta dvs.',
    buy_now: 'Cumpără acum',
    minimal_price: 'Prețul cerut',
    place_an_offer: 'Plasează oferta',
    place_an_different_offer: 'Plasează o ofertă diferită',
    buy_now_button: 'Cumpără acum',
    vehicle_description: 'Detalii vehicul',
    first_registration: 'Prima înmatriculare',
    total_mileage: 'Kilometrajul',
    zip_code: 'Codul poștal',
    origin_country: 'Țara de origine',
    import_description_options: {
      germany: 'Germania',
      austria: 'Austria',
      italy: 'Italia',
      netherlands: 'Olanda',
      usa: 'SUA',
      great_britain: 'Marea Britanie',
      france: 'Franța',
      belgium: 'Belgia',
      not_known: 'Necunoscut',
      other: 'Altele'
    },
    rental_description: 'Tipul de utilizare',
    rental_description_options: {
      demo: 'Motocicletă demo',
      driving_course: 'Motocicletă școală de conducere',
      rental: 'Motocicletă de închiriat'
    },
    used_commercially: 'Utilizat comercial',
    not_rental: 'Fără utilizare comercială',
    previous_owners: 'Numărul de proprietari anteriori',
    number_of_previous_owners_options: {
      _0_: '0',
      _1_: '1',
      _2_: '2',
      _3_: '3',
      _4_: '4',
      more_than_4: 'More than 4',
      not_known: 'Unknown'
    },
    addiction_info: 'Additional Information',
    accident_free: 'Accident Free',
    with_accident: 'Accident Vehicle',
    not_wrecked: 'Never Dropped',
    wrecked: 'Dropped',
    original_lacquer: 'Original Paint',
    not_original_lacquer: 'Not Original Paint',
    without_defects: 'No Other Damage',
    defects: 'Other Damage/Defects',
    with_trailer: 'Cu remorcă de transport',
    without_trailer: 'Fără remorcă de transport',
    accessories_description: 'Equipment and Accessories',
    admin_comment: 'Comments',
    not_financed_vehicle: 'Not Financed',
    financed_vehicle_1: 'Financed',
    abs: 'ABS',
    vin: 'VIN Number',
    without_abs: 'No ABS',
    not_imported: 'Not Imported',
    with_service_booklet: 'Service History',
    motorbike_service_booklet_options: {
      not_run: 'No Service History',
      existing: 'Service History Available',
      run: 'Complete Service History',
      digitally_run: 'Digital Service History'
    },
    not_categorized_attributes_section_title: 'Vehicle Details',
    general_condition_section_title: 'Vehicle Condition',
    score: 'Score',
    general_condition: 'General Condition',
    consumables_condition: 'Wear Parts',
    tires: 'Tires',
    tires_age: 'Vârsta anvelopelor',
    tires_condition: 'Profil anvelopă',
    motorbike_general_condition_options: {
      as_new: 'As New',
      well_maintained: 'Very Good',
      average: 'Minor Wear',
      bad: 'Accident Damaged',
      care: 'Needs Care',
      tatty: 'Poor'
    },
    motorbike_consumables_condition_options: {
      as_new: 'As New',
      well_maintained: 'Good',
      average: 'Fair',
      tatty: 'Poor',
      not_known: 'Unknown',
      bad: 'Bad',
      care: 'Adequate'
    },
    motorbike_tires_options: {
      '25%': '25%',
      '50%': '50%',
      '75%': '75%',
      bad: 'Worn or older than 6 years',
      very_well: 'Like New',
      not_known: 'Unknown'
    },
    motorbike_tires_age_options: {
      under_six_years_old: 'Sub 6 ani',
      over_six_years_old: '6 ani sau mai mult',
      not_known: 'Nu mă pricep'
    },
    motorbike_tires_condition_options: {
      _0_: 'Uzate',
      _25_: '25%',
      _50_: '50%',
      _75_: '75%',
      _100_: 'Ca noi',
      not_known: 'Nu mă pricep'
    },
    services: 'Inspections',
    motorbike_last_inspection: 'Last Service',
    motorbike_next_hu: 'Next Inspection',
    photos_screen_title: 'Gallery',
    camper_number_of_seats: 'Number of Seats',
    camper_commercial_use: 'Commercial Use',
    camper_without_commercial_use: 'No Commercial Use',
    bool_options: {
      true: 'Yes',
      false: 'No'
    },
    camper_type: 'Vehicle Type',
    camper_type_options: {
      caravan: 'Caravan',
      van: 'Van/CUV',
      semi_integrated: 'Semi-Integrated',
      fully_integrated: 'Fully Integrated',
      alcove: 'Alcove',
      luxury: 'Luxury Liner',
      car: 'Car'
    },
    camper_next_hu: 'Next Inspection',
    camper_last_inspection: 'Last Inspection',
    agricultural_production_year: 'Year of Manufacture',
    agricultural_meter: 'Mileage',
    agricultural_general_condition_options: {
      as_new: 'New',
      well_maintained: 'Lightly Used',
      average: 'Used',
      bad: 'Needs Repair',
      care: '',
      tatty: ''
    }
  },
  browse: 'Vehicule',
  all_vehicles: 'Toate vehiculele',
  liked_vehicles: 'Favorite',
  first_offer: 'Fără oferte',
  highest_offer: 'Depășit',
  highest_offer_short: 'Cea mai mare ofertă',
  first_offer_short: 'Fără oferte',
  buy_now: 'Cumpără acum',
  no_offers: 'În prezent nu există vehicule \n care să corespundă criteriilor dvs.',
  offer_to_low: 'Ofertă minimă € ',
  date: 'Prima înmatriculare',
  agricultural_production_year: 'Anul',
  mileage: 'Kilometrajul',
  country: 'Locația',
  bets_count: 'Numărul de oferte',
  your_offer: 'Oferta dvs.',
  buy_now_expanded_view: 'Cumpără acum',
  minimal_offering: 'Prețul cerut',
  new_offer_button: 'Plasează oferta',
  buy_now_button: 'Cumpără acum',
  bets_table_title: 'Ofertele dvs.',
  archive_tab_title: 'Arhiva cumpărăturilor',
  sold_tab_title: 'Arhiva vânzărilor',
  company_data_title: 'Datele companiei',
  company_data: 'Datele companiei',
  in_realization_table: 'În progres',
  messages: 'Mesaje',
  auctions: 'Ofertele mele',
  in_realization: 'În progres',
  invoices: 'Facturi',
  archive: 'Arhivă',
  my_auctions: 'Cumpărături',
  accepted_offer: 'Oferta acceptată',
  archived_date: 'Arhivat',
  sold: 'Vândut',
  app_should_be_updated: 'O nouă versiune a aplicației este disponibilă',
  update: 'Actualizează',
  Motorbike_offers: 'Motociclete',
  JetSki_offers: 'Jet Ski-uri',
  AgriculturalMachine_offers: 'Mașini agricole',
  Camper_offers: 'Autocaravane și rulote',
  message_placeholder: 'Scrie mesajul',
  application_version: 'Versiunea aplicației',
  remove_account: 'Șterge contul',
  log_out: 'Deconectare',
  profile: 'Profil',
  profile_settings: 'Datele principale',
  auth_settings: 'SETĂRI APLICAȚIE',
  update_application: 'Actualizează',
  check_updates: 'Verifică disponibilitatea',
  remove_account_confirmation: 'Sunteți sigur că doriți să ștergeți contul?',
  set_password: 'Setează parola',
  set_language: 'Limba',
  integrations: 'Integrări',
  integrations_screen: {
    title: 'Integrări',
    login: 'Login',
    password: 'Parolă',
    add: 'Adaugă integrare',
    empty: 'Nu există încă o integrare conectată.',
    cancel: 'Anulează',
    connect: 'Conectează',
    connected: 'Cont conectat',
    seller_id: 'ID vânzător',
    sync: 'Sincronizează vehiculele',
    sync_started: 'Sincronizarea a pornit. Vehiculele vor apărea în lista de vehicule.',
    connect_success: 'Contul mobile.de a fost conectat',
    connect_error: 'Contul nu a putut fi conectat',
    load_error: 'Integrările nu au putut fi încărcate',
    sync_error: 'Sincronizarea nu a putut fi pornită',
    disconnect: 'Șterge integrarea',
    disconnect_title: 'Ștergi integrarea?',
    disconnect_message:
      'Contul va fi deconectat. Anunțurile rămân pe mobile.de. Apoi poți adăuga integrarea din nou, de exemplu cu o parolă nouă.',
    disconnect_confirm: 'Șterge',
    disconnect_success: 'Integrarea a fost ștearsă',
    disconnect_error: 'Integrarea nu a putut fi ștearsă'
  },
  profile_settings_screen_header: 'Setări',
  save_password: 'Salvează',
  update_password_form: {
    current_password: 'Parola actuală',
    new_password: 'Parola nouă',
    confirm_new_password: 'Confirmă parola',
    password_not_match: 'Parolele nu se potrivesc',
    password_do_not_meet_requirements:
      'Parola trebuie să aibă cel puțin 8 caractere și să conțină litere mari și mici și un caracter special precum "!@#$%^&*"',
    current_password_invalid: 'Parola actuală este incorectă',
    password_to_short: 'Parola este prea scurtă (minimum 8 caractere)',
    unknown_error: 'Ceva a mers prost. Vă rugăm să încercați din nou'
  },
  sign_in_screen: {
    do_not_have_account: 'Nu aveți încă cont?',
    registration: 'Înregistrează-te acum',
    registration_url: 'https://estigroup.de',
    title: 'Autentificare',
    forgot_password: 'Ați uitat parola?',
    sign_in: 'Autentificare',
    forgot_password_title: 'Resetează parola',
    forgot_password_description:
      'Introduceți adresa dvs. de e-mail și vă vom trimite un link pentru resetarea parolei.',
    reset_password: 'Resetează parola',
    remind_password: 'Trimite',
    reset_instructions_sent: 'Instrucțiunile de resetare a parolei au fost trimise pe email-ul dvs.',
    password_invalid: 'Parolă incorectă',
    email_invalid: 'Email invalid',
    repeat_password: 'Repetă parola',
    password: 'Parola',
    password_requirement_uppercase: 'Min. 1 literă mare',
    password_requirement_number: 'Min. 1 cifră',
    password_requirement_special_char: 'Min. 1 caracter special (!#$%@*^&)',
    password_requirement_min_length: 'Min. 8 caractere'
  },
  profile_settings_form: {
    name: 'Numele',
    last_name: 'Numele de familie',
    nickname: 'Prenumele',
    phone: 'Telefonul',
    email: 'Email',
    company_name: 'Numele companiei',
    ftin: 'CUI',
    street: 'Strada',
    zip_code: 'Codul poștal',
    place: 'Orașul',
    iban: 'IBAN',
    bic: 'BIC',
    save: 'Salvează'
  },
  filter_modal: {
    localization: 'Locația',
    vehicle: 'Vehiculul',
    hash_id: 'Numărul ID',
    damaged_label: 'Starea vehiculului',
    damaged: 'Avariat',
    not_damaged: 'Neavariat',
    all: 'Toate',
    year_form: 'Anul de la',
    year_to: 'Anul până la',
    milage_from: 'Kilometri de la',
    milage_to: 'Kilometri până la',
    zpi_code_input: 'Codul poștal',
    area: 'Raza',
    country: 'Țara',
    filter_offers: 'Rafinează căutarea',
    filter_button: 'Ascunde',
    motorbikes: 'Motociclete',
    agricultural_machines: 'Mașini agricole',
    campers: 'Autocaravane și rulote',
    vehicle_type: 'Tipul de vehicul',
    motorbike_model: 'Modelul',
    motorbike_brand: 'Marca',
    brand_options: [
      {
        optionLabel: 'Access Motor',
        optionVal: 33
      },
      {
        optionLabel: 'Aprilia',
        optionVal: 3
      },
      {
        optionLabel: 'BMW',
        optionVal: 2
      },
      {
        optionLabel: 'Benelli',
        optionVal: 18
      },
      {
        optionLabel: 'Beta',
        optionVal: 23
      },
      {
        optionLabel: 'Bimota',
        optionVal: 20
      },
      {
        optionLabel: 'Buell',
        optionVal: 4
      },
      {
        optionLabel: 'CFMoto',
        optionVal: 28
      },
      {
        optionLabel: 'Can Am',
        optionVal: 31
      },
      {
        optionLabel: 'Daelim',
        optionVal: 24
      },
      {
        optionLabel: 'Ducati',
        optionVal: 5
      },
      {
        optionLabel: 'Harley-Davidson',
        optionVal: 6
      },
      {
        optionLabel: 'Honda',
        optionVal: 1
      },
      {
        optionLabel: 'Husaberg',
        optionVal: 26
      },
      {
        optionLabel: 'Husqvarna',
        optionVal: 7
      },
      {
        optionLabel: 'Hyosung',
        optionVal: 25
      },
      {
        optionLabel: 'Indian',
        optionVal: 8
      },
      {
        optionLabel: 'KTM',
        optionVal: 10
      },
      {
        optionLabel: 'Kawasaki',
        optionVal: 9
      },
      {
        optionLabel: 'Kymco',
        optionVal: 22
      },
      {
        optionLabel: 'MV Agusta',
        optionVal: 12
      },
      {
        optionLabel: 'Moto-Guzzi',
        optionVal: 11
      },
      {
        optionLabel: 'Peugeot',
        optionVal: 27
      },
      {
        optionLabel: 'Piaggio',
        optionVal: 19
      },
      {
        optionLabel: 'Polaris',
        optionVal: 30
      },
      {
        optionLabel: 'Royal Enfield',
        optionVal: 32
      },
      {
        optionLabel: 'Suzuki',
        optionVal: 13
      },
      {
        optionLabel: 'TGB',
        optionVal: 29
      },
      {
        optionLabel: 'Triumph',
        optionVal: 14
      },
      {
        optionLabel: 'Vespa',
        optionVal: 21
      },
      {
        optionLabel: 'Victory',
        optionVal: 15
      },
      {
        optionLabel: 'Yamaha',
        optionVal: 16
      }
    ]
  },
  my_vehicles: {
    title: 'Vehiculele mele',
    in_stock: 'În stoc',
    sold: 'Vândute',
    add_vehicle: 'Adaugă vehicul',
    edit_vehicle: 'Editează vehiculul',
    vehicle: 'Vehicul',
    actions: 'Acțiuni',
    details: 'Detalii vehicul',
    mark_as_sold: 'Marchează vehiculul ca vândut',
    mark_as_in_stock: 'Readu vehiculul în stoc',
    toast_marked_sold: '{{name}} a fost marcat ca vândut',
    toast_restored_stock: '{{name}} a fost readus în stoc',
    toast_vehicle_fallback: 'vehiculul',
    toast_vehicle_added: 'Vehicul adăugat',
    toast_issue_invoice: 'Emite factură',
    documents: 'Documente',
    no_documents: 'Nu există documente pentru acest vehicul',
    photos: 'Fotografii',
    photos_empty: 'Acest vehicul nu are încă fotografii.',
    add_photo: 'Adaugă fotografie',
    delete_photo_title: 'Ștergi fotografia?',
    delete_photo_message: 'Fotografia va fi ștearsă din galeria acestui vehicul.',
    photo_added: 'Fotografia a fost adăugată',
    photo_deleted: 'Fotografia a fost ștearsă',
    photo_type_error: 'Sunt permise doar fișiere JPEG și PNG.',
    photo_upload_error: 'Fotografia nu a putut fi salvată',
    edit: 'Editează',
    delete: 'Șterge',
    view_offer: 'Vezi oferta',
    empty_title: 'Adaugă primul vehicul',
    empty_subtitle: 'Pentru fiecare motocicletă vei emite documente pentru clienții tăi.',
    sold_empty_title: 'Ai vândut un vehicul? Marchează-l ca vândut.',
    sold_empty_subtitle: 'Îl mutăm aici cu toată documentația, ca să ai ordine în vehiculele din stoc.',
    vehicle_data: 'Date vehicul',
    source_purchased: 'Alege din achiziționate',
    source_own: 'Adaugă vehicul propriu',
    brand: 'Marcă',
    model: 'Model',
    year: 'An',
    mileage: 'Kilometraj',
    vin: 'VIN',
    choose: 'Alege',
    mileage_placeholder: 'ex.  2500',
    vin_placeholder: 'ex. JYARM22E0LA001234',
    vin_tooltip: 'Numărul de identificare al vehiculului (17 caractere).',
    discard: 'Renunță',
    add: 'Adaugă',
    save: 'Salvează',
    km: 'km',
    ccm: 'cm³',
    kw: 'kW',
    field_integer: 'Introduceți un număr întreg',
    search_purchased: 'Caută motociclete...',
    choose_vehicle: 'Alege vehiculul',
    loading_offers: 'Se încarcă...',
    no_purchased: 'Nu s-au găsit motociclete',
    field_required: 'Completează acest câmp',
    promotion: 'Promovări',
    promotion_empty_title: 'Nicio promovare',
    promotion_empty_subtitle: 'Când anunțul este pe mobile.de sau pe alt portal, de exemplu Otomoto, apare aici.',
    promotion_mobile: 'mobile.de',
    promotion_otomoto: 'Otomoto',
    promotion_listed: 'Anunțul este publicat',
    promotion_paused: 'Suspendat',
    promotion_pause: 'Suspendă',
    promotion_resume: 'Reia',
    promotion_delete: 'Șterge',
    promotion_public_link: 'Vezi anunțul',
    add_promotion: 'Adaugă promovare',
    promotion_photos: 'Fotografii în anunț',
    promotion_photos_pick: 'Alege fotografii',
    promotion_photos_none: 'Anunțul va fi creat fără fotografii.',
    promotion_photos_empty: 'Acest vehicul nu are fotografii. Adaugă-le pe pagina vehiculului.',
    promotion_photos_hint: 'Alege fotografii din galeria acestui vehicul.',
    promotion_photos_limit: 'Poți alege cel mult {{count}} fotografii.',
    promotion_photos_confirm: 'Salvează selecția',
    promotion_photo_cover: 'Principală',
    promotion_photo_make_cover: 'Setează principală',
    edit_promotion: 'Editează promovarea',
    promotion_form_title: 'Promovare pe mobile.de',
    promotion_price: 'Preț',
    promotion_price_placeholder: 'ex. 12500',
    promotion_category: 'Categorie',
    promotion_description: 'Descriere',
    promotion_description_placeholder: 'Descrierea anunțului',
    promotion_description_bold: 'Aldin',
    promotion_description_list: 'Listă',
    promotion_description_rule: 'Linie',
    promotion_description_undo: 'Anulează',
    promotion_description_redo: 'Refă',
    promotion_highlight: 'Punct forte',
    promotion_highlight_placeholder: 'ex. ABS',
    promotion_section_vehicle: 'Vehicul',
    promotion_section_equipment: 'Dotări',
    promotion_section_service: 'Service',
    promotion_power: 'Putere',
    promotion_capacity: 'Capacitate',
    promotion_drive_type: 'Transmisie',
    promotion_gear_box: 'Cutie de viteze',
    promotion_color: 'Culoare',
    promotion_metallic: 'Vopsea metalizată',
    promotion_vat: 'TVA',
    promotion_damage: 'Daune nereparate',
    promotion_abs: 'ABS',
    promotion_heated_grips: 'Mânere încălzite',
    promotion_box: 'Topcase',
    promotion_windshield: 'Parbriz',
    promotion_kickstarter: 'Kickstarter',
    promotion_owners: 'Proprietari anteriori',
    promotion_last_inspection: 'Ultima inspecție',
    promotion_new_inspection: 'Inspecție nouă',
    promotion_service_history: 'Istoric complet de service',
    promotion_yes: 'Da',
    promotion_no: 'Nu',
    promotion_month_placeholder: 'AAAA-LL',
    promotion_months: [
      'Ianuarie',
      'Februarie',
      'Martie',
      'Aprilie',
      'Mai',
      'Iunie',
      'Iulie',
      'August',
      'Septembrie',
      'Octombrie',
      'Noiembrie',
      'Decembrie'
    ],
    promotion_vat_23: '23%',
    promotion_vat_19: '19%',
    promotion_vat_none: 'TVA nedeductibil',
    promotion_gear_manual: 'Manuală',
    promotion_gear_automatic: 'Automată',
    promotion_drive_chain: 'Lanț',
    promotion_drive_belt: 'Curea',
    promotion_drive_shaft: 'Cardan',
    promotion_colors: {
      BLACK: 'Negru',
      GREY: 'Gri',
      BEIGE: 'Bej',
      BROWN: 'Maro',
      RED: 'Roșu',
      GREEN: 'Verde',
      BLUE: 'Albastru',
      PURPLE: 'Violet',
      GOLD: 'Auriu',
      WHITE: 'Alb',
      ORANGE: 'Portocaliu',
      SILVER: 'Argintiu',
      YELLOW: 'Galben'
    },
    promotion_create_error: 'Promovarea pe mobile.de nu a putut fi adăugată.',
    promotion_update_error: 'Promovarea pe mobile.de nu a putut fi salvată.',
    toast_promotion_added: 'Promovarea pe mobile.de a fost adăugată',
    toast_promotion_updated: 'Promovarea pe mobile.de a fost actualizată',
    toast_promotion_paused: 'Anunțul a fost suspendat pe mobile.de',
    toast_promotion_deleted: 'Anunțul a fost șters de pe mobile.de',
    toast_promotion_resumed: 'Anunțul a fost publicat din nou pe mobile.de',
    promotion_categories: {
      ChopperAndCruiser: 'Chopper / cruiser',
      CombinationAndSidecar: 'Motocicletă cu ataș',
      DirtBike: 'Cross',
      EnduroAndTouringEnduro: 'Enduro',
      LightweightMotorcycleAndMotorbike: 'Motocicletă ușoară',
      MotorAssistedBicycleAndSmallMoped: 'Moped',
      Motorcycle: 'Motocicletă',
      NakedBike: 'Naked',
      Pocketbike: 'Pocket bike',
      Racing: 'Competiție',
      RallyAndCross: 'Raliu / cross',
      Scooter: 'Scuter',
      SportTouringMotorcycle: 'Sport touring',
      SportsAndSuperSportsBike: 'Sport',
      Streetfighter: 'Streetfighter',
      SuperMoto: 'Supermoto',
      Tourer: 'Touring',
      Trike: 'Trike',
      OtherMotorbike: 'Altă',
      Quad: 'ATV'
    },
    add_document: 'Adaugă document',
    document_invoice: 'Factură',
    document_sell_contract: 'Contract de vânzare',
    document_import: 'Document de import',
    document_open: 'Deschide',
    document_download: 'Descarcă',
    documents_empty_title: 'Adaugă primul document',
    documents_empty_subtitle: 'Aici poți emite factura, contractul și documentul de import pentru această motocicletă.'
  },
  clients: {
    title: 'Clienți',
    add_client: 'Adaugă client',
    name: 'Nume client',
    email: 'E-mail',
    phone: 'Număr de telefon',
    country: 'Țară',
    actions: 'Acțiuni',
    details: 'Detalii client',
    edit: 'Editează',
    delete: 'Șterge',
    copy_email: 'Copiază e-mailul',
    email_copied: 'Copiat',
    empty_title: 'Adaugă primul client',
    empty_subtitle: 'Clienții vor apărea aici după ce îi adaugi.',
    edit_client: 'Editează clientul',
    client_data: 'Date client',
    company: 'Firmă',
    personal: 'Persoană fizică',
    company_name: 'Numele firmei',
    document_number: 'Număr document',
    vat_number: 'Număr TVA',
    id_number: 'Număr act de identitate',
    place: 'Localitate',
    zip_code: 'Cod poștal',
    street: 'Stradă',
    house_number: 'Număr casă',
    first_name: 'Prenume',
    last_name: 'Nume',
    company_name_placeholder: 'ex. AutoMoto S.R.L.',
    document_number_placeholder: 'ex. 12345678',
    vat_number_placeholder: 'ex. RO12345678',
    id_number_placeholder: 'ex. RX123456',
    place_placeholder: 'ex. București',
    zip_code_placeholder: 'ex. 010011',
    street_placeholder: 'ex. Calea Victoriei',
    house_number_placeholder: 'ex. 12',
    first_name_placeholder: 'ex. Andrei',
    last_name_placeholder: 'ex. Popescu',
    email_placeholder: 'ex. a.popescu@automoto.ro',
    phone_placeholder: 'ex. +40 721 234 567',
    tax_number: 'Număr fiscal',
    full_name: 'Nume și prenume',
    city: 'Oraș',
    documents: 'Lista documentelor',
    documents_empty_subtitle:
      'Aici poți emite factura, contractul de vânzare și documentul de import pentru acest client.',
    search: 'Caută',
    document_invoice: 'Factură',
    document_contract: 'Contract',
    document_import: 'Document de import',
    countries: {
      poland: 'Polonia',
      germany: 'Germania'
    }
  },
  sell_contract: {
    contract_data: 'Date contract',
    vehicle: 'Vehicul',
    client: 'Client',
    contract_language: 'Limba contractului',
    select: 'Selectează',
    select_client: 'Selectează clientul',
    select_vehicle: 'Selectează vehiculul',
    search_clients: 'Caută clienți...',
    no_clients: 'Nu s-au găsit clienți',
    currency: 'Monedă',
    vat_rate: 'Cotă TVA',
    price: 'Preț',
    gross: 'Brut',
    net: 'Net',
    net_price: 'Preț net',
    vat: 'TVA ({{rate}}%)',
    gross_price: 'Preț brut',
    additional_services: 'Servicii suplimentare',
    additional_service_name: 'Denumire',
    additional_service_amount: 'Sumă',
    additional_service_add: 'Adaugă serviciu',
    additional_service_remove: 'Șterge',
    additional_service_total: 'Preț total',
    down_payment: 'Avans',
    down_payment_amount: 'Suma avansului',
    payment_method: 'Metodă de plată',
    payment_type: 'Tip de plată',
    bank_transfer: 'Transfer bancar',
    instant_transfer: 'Transfer instant',
    cash: 'Numerar',
    financing: 'Finanțare',
    date: 'Dată',
    on_contract: 'Contract',
    down_payment_date: 'Data avansului',
    delivery: 'Livrare',
    date_format: 'Format dată',
    exact_date: 'Dată exactă',
    time_span: 'Interval',
    delivery_date: 'Data livrării',
    delivery_period: 'Perioada de livrare',
    commitment: 'Angajament',
    binding: 'Obligatoriu',
    non_binding: 'Neobligatoriu',
    delivery_method: 'Metodă de livrare',
    delivery_place: 'Loc sau adresă de livrare',
    additional_service_delivery_cost: 'Acesta este costul predării',
    payment_due: 'Scadența plății',
    payment_due_handover: 'La predare contra factură',
    payment_due_custom: 'Alt termen',
    payment_due_text: 'Termen convenit',
    registration_state: 'Starea înmatriculării la predare',
    registration_deregistered: 'Dezînmatriculat',
    registration_registered: 'Înmatriculat',
    registration_by: 'Înmatricularea o face',
    registration_seller: 'Vânzătorul',
    registration_buyer: 'Cumpărătorul',
    client_delivery: 'Ridicare client',
    dealer_delivery: 'Livrare dealer',
    damages: 'Daune și abateri',
    remarks: 'Observații / altele',
    remarks_hint: 'Aici poți introduce defectele, daunele, problemele cunoscute și alte informații despre vehicul.',
    previous_owner_damages: 'Daune și abateri ale proprietarului anterior',
    yes: 'Da',
    no: 'Nu',
    not_specified: 'Nespecificat',
    exclude_updates:
      'Obligația de actualizare a produselor digitale și a bunurilor cu elemente digitale să fie exclusă?',
    shorten_warranty: 'Scurtează garanția la un an',
    language_de: 'Germană',
    language_pl: 'Poloneză',
    vat_23: '23% TVA',
    vat_10: '10% TVA',
    vat_5: '5% TVA',
    vat_marginal: 'Taxare marjă',
    vat_small_business: 'Întreprindere mică',
    month_1: '1 lună',
    month_2: '2 luni',
    month_3: '3 luni',
    month_4: '4 luni',
    month_5: '5 luni',
    description: 'Descriere',
    objective_deviations: 'Există abateri de la cerințele obiective?',
    objective_deviation_1: 'Descrierea abaterii',
    objective_deviation_placeholder: 'Element, stare și consecințele utilizării',
    further_agreements: 'Acorduri suplimentare privind starea',
    further_agreements_placeholder: 'Lasă gol dacă nu s-a stabilit nimic',
    eur: 'EUR (€)',
    pln: 'PLN (zł)',
    date_placeholder: 'ZZ.LL.AAAA',
    field_required: 'Completează acest câmp',
    vin_value: 'VIN: {{vin}}',
    mileage_value: 'Kilometraj {{mileage}}',
    year_value: 'An: {{year}}',
    email_value: 'E-mail: {{email}}',
    phone_value: 'Telefon: {{phone}}',
    address_value: 'Adresă: {{address}}',
    mileage_statement: 'Declarație privind kilometrajul',
    mileage_statement_known: 'Kilometrajul este cunoscut',
    mileage_statement_unknown: 'Kilometrajul nu este cunoscut',
    mileage_statement_custom: 'Altă înțelegere privind kilometrajul',
    mileage_statement_text: 'Textul înțelegerii privind kilometrajul',
    previous_owners_basis: 'Baza informației despre proprietarii anteriori',
    previous_owners_basis_placeholder: 'Documente sau informații concrete',
    key_count: 'Număr de chei',
    other_equipment: 'Alte echipamente',
    missing_items: 'Documente sau piese lipsă'
  },
  unsaved_changes: {
    title: 'Ai modificări nesalvate',
    body: 'Dacă ieși acum, datele introduse vor fi pierdute.',
    leave: 'Ieși fără salvare',
    stay: 'Înapoi la editare'
  },
  mobile_redirect: {
    title: 'Descarcă aplicația noastră mobilă',
    subtitle: 'pentru a naviga prin anunțurile actuale și a explora platforma în modul demo.',
    step1: 'Descarcă aplicația Estimoto pe telefonul tău (Android/iOS).',
    step2: 'Conectează-te folosind',
    step2_highlight: 'aceeași adresă de email',
    step3: 'și parola trimisă în inbox-ul tău.',
    step4: 'Vei avea acces la versiunea demo și la oferte reale, actualizate de motociclete.',
    open_app: 'Deschide aplicația mobilă',
    google_play: 'Google Play',
    app_store: 'App Store'
  },
  invoice_form: {
    sales_invoices: 'Facturi de vânzare',
    add_invoice: 'Adaugă factură',
    edit_invoice: 'Editează factura',
    invoice_data: 'Date client',
    nip: 'CIF: {{number}}',
    invoice_number: 'Număr factură',
    invoice_number_placeholder: 'ex. FV/2026/001',
    invoice_language: 'Limba facturii',
    language_en: 'Engleză',
    invoice_date: 'Data facturii',
    payment_due: 'Scadență plată',
    additional_info: 'Informații suplimentare'
  }
}
